export default "__VITE_ASSET__Dpd8fHBY__"